// backend returns translatable fields as `{ pl, en }` objects, but `[]` when empty
const toLocalizedField = (value?: ILocalizedField | unknown[] | null): ILocalizedField => {
	if (!value || Array.isArray(value)) return {}
	return { ...value }
}

const toNullableLocalizedField = (value: ILocalizedField): ILocalizedField | null => {
	const result: ILocalizedField = {}
	Object.entries(value).forEach(([code, text]) => {
		const trimmed = (text ?? '').trim()
		if (trimmed) result[code] = trimmed
	})
	return Object.keys(result).length ? result : null
}

export const Author = (json: IAuthor): IAuthorModel => {
	return {
		id: Number(json.id),
		givenName: json.given_name ?? '',
		familyName: json.family_name ?? '',
		jobTitle: toLocalizedField(json.job_title),
		description: toLocalizedField(json.description),
		worksFor: json.works_for ?? '',
		sameAs: Array.isArray(json.same_as) ? json.same_as.filter((link) => typeof link === 'string' && link.trim()) : [],
	}
}

export const authorToJSON = (obj: Omit<IAuthorModel, 'id'>): IAuthorArguments => {
	const sameAs = obj.sameAs.map((link) => link.trim()).filter(Boolean)

	return {
		given_name: obj.givenName.trim(),
		family_name: obj.familyName.trim(),
		job_title: toNullableLocalizedField(obj.jobTitle),
		description: toNullableLocalizedField(obj.description),
		works_for: obj.worksFor.trim() || null,
		same_as: sameAs.length ? sameAs : null,
	}
}

export const authorFullName = (author?: Pick<IAuthorModel, 'givenName' | 'familyName'> | null) => {
	if (!author) return ''
	return [author.givenName, author.familyName].filter(Boolean).join(' ')
}
